import styled, { css } from 'styled-components';

export const DropdownWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  max-height: 200px;
  overflow: auto;
  background: ${({ theme }) => theme.colors.base};
  border: 1px solid ${({ theme }) => theme.colors.default[100]};
  border-radius: 4px;
  padding: 12px 0;
  max-width: 600px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    max-height: 80vh;
    max-width: revert;
  }
`;

export const DropdownContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const DropdownItem = styled.button<{
  $selected?: boolean;
  $disabled: boolean;
}>`
  width: 100%;
  text-align: left;
  padding: 4px 12px;
  color: ${({ theme }) => theme.colors.default.default};

  ${({ theme }) => theme.breakpoints.md.query} {
    padding: 12px;

    &:not(:last-of-type) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.default[100]};
    }
  }

  ${({ $selected, $disabled }) =>
    $disabled
      ? css`
          pointer-events: none;
          opacity: 0.6;
        `
      : $selected
        ? css`
            background: ${({ theme }) => theme.colors.default[50]};
          `
        : css`
            &:hover,
            &:focus-within {
              background: ${({ theme }) => theme.colors.default[50]};
            }
          `};
`;
